<template>
  <div class="vdci-switch-container">
    <div class="flex">
      <img v-if="icon" v-bind:class="{ border: iconBorder }" :src="icon" />
      <label for="basic-switch">{{ label }}</label>
    </div>
    <div :id="idName" class="mdc-switch">
      <div class="mdc-switch__track"></div>
      <div class="mdc-switch__thumb-underlay">
        <div class="mdc-switch__thumb"></div>
        <input
          type="checkbox"
          id="basic-switch"
          class="mdc-switch__native-control"
          role="switch"
          :checked="active"
          :aria-checked="active"
          @change="localOnChange(!active, label)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { MDCSwitch } from '@material/switch';

export default {
  props: {
    icon: String,
    iconBorder: Boolean,
    label: String,
    active: Boolean,
    onChange: Function,
    disabled: Boolean,
  },

  computed: {
    idName() {
      return this.label.replaceAll(' ', '-');
    },
  },

  methods: {
    localOnChange(newActive, label) {
      this.active = newActive;
      this.onChange(newActive, label);
    },
  },

  mounted() {
    this.switchControl = new MDCSwitch(document.getElementById(this.idName));
  },
};
</script>

<style lang="scss">
@import '../../assets/scss/variables';

.vdci-switch-container {
  display: flex;
  justify-content: space-between;

  & img {
    align-self: center;
    position: relative;
    margin-right: 1rem;
    top: -12px;
    width: 24px;
    height: 24px;

    &.border {
      border: 1px solid $blue;
      border-radius: 50%;
    }
  }

  & label {
    align-self: center;
    color: #333333;
    font-family: Roboto;
    font-size: 11px;
    font-weight: normal;
    position: relative;
    top: -10px;
    height: fit-content;
  }

  & .mdc-switch {
    margin: 0 0 2.75rem 0;

    &.mdc-switch--checked {
      & .mdc-switch__track {
        background-color: $transparent-blue !important;
      }

      & .mdc-switch__thumb-underlay .mdc-switch__thumb {
        border-color: $blue;
      }

      & .md-ripple {
        color: $blue;
      }
    }
  }
}
</style>
